// Simple helper to get a Google reCAPTCHA v3 token
// Usage: const token = await getRecaptchaToken('contact_submit');
export async function getRecaptchaToken(action = 'submit') {
  try {
    if (!window.grecaptcha) {
      console.warn('reCAPTCHA not yet loaded');
      return null;
    }
    await window.grecaptcha.ready(async () => {});
    const siteKey = '6Lfn2bYrAAAAAMSCJMb0U1fRD1loqPq59KVhJfrT';
    const token = await window.grecaptcha.execute(siteKey, { action });
    return token;
  } catch (e) {
    console.error('reCAPTCHA token error:', e);
    return null;
  }
}
